import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';
import { BaseTable } from '../BaseTable/BaseTable';
import { sentPromoCodesColumns } from './user.constant';

const SentPromoCodesPanel = ({ isReadOnly = false, data }) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600, color: '#212B36' }}>
        Promo Codes Sent to Customer
      </Typography>
      <BaseTable
        rows={data || []}
        columns={sentPromoCodesColumns(isReadOnly)}
        loading={false}
        getRowId={(row) => row?.promo_code_audit_id}
        pageSize={10}
        pagination={true}
        sx={{
          '& .MuiDataGrid-root': {
            border: '1px solid rgba(145, 158, 171, 0.12)',
            borderRadius: 1,
          }
        }}
      />
    </Box>
  );
};

export default SentPromoCodesPanel;
